<template>
  <a-modal width="800px" :visible="visible" :closable="false">
    <h5 class="mt-2 mb-3">
      {{ $t('adjustment.revisedListTitle') }}
    </h5>
    <a-spin :spinning="isLoading" size="large" :tip="$t('adjustment.uploading')">
      <div>
        <a-table
          :columns="columns"
          :row-key="(record, index) => index"
          :data-source="revisedData"
          :loading="isLoading"
          :pagination="false"
          :scroll="{ y: 330 }"
        >
          <template slot="status" slot-scope="text">
            <a-tag v-if="text.includes('sku_not_found')" color="red">
              {{ $t('adjustment.skuNotFound') }}
            </a-tag>
            <a-tag v-if="text.includes('uom_not_valid')" color="orange">
              {{ $t('adjustment.uomNotValid') }}
            </a-tag>
            <a-tag v-if="text.includes('data_not_valid')" color="purple">
              {{ $t('adjustment.dataNotValid') }}
            </a-tag>
          </template>
        </a-table>
      </div>
    </a-spin>
    <template #footer>
      <a-button key="back" class="mr-2" @click="typeof back !== 'undefined' && back(), onClose()">
        {{ $t('adjustment.closeNoDownload') }}
      </a-button>
      <a-button type="primary" class="mr-2" @click.prevent="downloadTemplate">
        <a-icon type="download" />
        {{ $t('adjustment.closeDownloadRevised') }}
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import getQueryParam from '@/utils/getQueryParam'
import XLSX from 'xlsx';

export default {
  name: 'ModalFeedbackAfterImport',
  components: {
  },
  mixins: [getQueryParam],
  props: {
    revisedData: Array,
    visible: Boolean,
    back: Function,
    onClose: Function,
    isLoading: Boolean,
  },
  data: function () {
    return {
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('productAvailability.sku'),
          dataIndex: 'sku',
          key: 'sku',
          width: 250,
        },
        {
          title: this.$t('utils.quantity'),
          dataIndex: 'quantity',
          width: 100,
          key: 'quantity',
        },
        {
          title: this.$t('adjustment.revisedStatus'),
          dataIndex: 'status',
          key: 'status',
          width: 150,
          scopedSlots: {
            customRender: 'status',
          },
        },
      ]
    },
  },
  methods: {
    downloadTemplate() {
      const flattenData = this.revisedData.map((obj) => ({
        sku: obj.sku,
        quantity: obj.quantity,
      }))
      const rowData = [
        "SKU",
        "Quantity",
      ]
      const worksheet = XLSX.utils.json_to_sheet(flattenData);
      const workbook = XLSX.utils.book_new()
      XLSX.utils.sheet_add_aoa(worksheet, [rowData], { origin: "A1" });
      XLSX.utils.book_append_sheet(workbook, worksheet, 'data')
      XLSX.writeFile(workbook,'file_revised_data_stock_adjustment.xlsx')
      this.onClose()
    },
  },
}
</script>

<style lang="scss" module>
</style>